import(/* webpackMode: "eager" */ "/app/app/hosting/guidelines/page.tsx");
